import { distinctUntilChanged } from 'rxjs';

export const jsonDistinct = <T>() => distinctUntilChanged<T>((a, b) => JSON.stringify(a) === JSON.stringify(b));
